import React from 'react'
import { Box } from 'pcln-design-system'
import { IconContainer, Arrow, ThoughtBubble } from './PhoneSalesBannerStyledComponents'
import { User } from 'pcln-icons'

const PhoneSalesFlyInIcon = () => {
  return (
    <IconContainer
      data-testid='money-on-mind-icon'
      bg={'secondary.base'}
      width='58px'
      justifyContent='center'
      alignItems='center'
      mr={3}
    >
      <Box pt={1}>
        <ThoughtBubble
          bg='text.lightest'
          color={'secondary.base'}
          width='18px'
          textAlign='center'
          fontSize={0}
          ml='auto'
          mr='1px'
        >
          $
        </ThoughtBubble>
        <Arrow mt='-1px' ml='auto' mr='15px' />
        <User mt='-4px' size={44} color='text.lightest' />
      </Box>
    </IconContainer>
  )
}

export default PhoneSalesFlyInIcon
